/**
 * ResponsiveTableWrapper - AWLP Design System
 * Horizontal scroll container for wide data tables on narrow viewports.
 * Pair with a table that declares its own min-width.
 */

import styled from 'styled-components';

export const ResponsiveTableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
`;

export default ResponsiveTableWrapper;
